import { Monitor, Moon, Sun } from "lucide-react";

import { useTheme, type ThemeMode } from "@/config/theme";
import { cn } from "@/lib/utils";

const options: { mode: ThemeMode; label: string; Icon: typeof Sun }[] = [
  { mode: "light", label: "Light", Icon: Sun },
  { mode: "dark", label: "Dark", Icon: Moon },
  { mode: "system", label: "System", Icon: Monitor },
];

export function ThemeToggle({ className }: { className?: string }) {
  const { mode, setMode } = useTheme();

  return (
    <div
      role="radiogroup"
      aria-label="Colour theme"
      className={cn(
        "inline-flex items-center gap-0.5 rounded-full border border-current/15 p-0.5",
        className,
      )}
    >
      {options.map(({ mode: value, label, Icon }) => (
        <button
          key={value}
          role="radio"
          aria-checked={mode === value}
          aria-label={`${label} theme`}
          onClick={() => setMode(value)}
          className={cn(
            "grid h-9 w-9 place-items-center rounded-full transition-colors duration-200",
            "hover:bg-current/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-current",
            mode === value && "bg-current/15",
          )}
        >
          <Icon className="h-4 w-4" aria-hidden />
        </button>
      ))}
    </div>
  );
}
